import { useAuthStore } from '../stores/authStore';

export type UserRole = 'admin' | 'manager' | 'user' | 'viewer';

export function usePermission() {
  const { user } = useAuthStore();
  const role = (user?.role as UserRole) || 'viewer';

  const isViewer = role === 'viewer';
  const isUser = role === 'user';
  const isManager = role === 'manager';
  const isAdmin = role === 'admin';
  const isManagerOrAdmin = isAdmin || isManager;

  return {
    role,
    isViewer,
    isUser,
    isManager,
    isAdmin,
    isManagerOrAdmin,

    // 権限レベルチェック
    canEdit: !isViewer, // viewer以外は編集可能
    canDelete: !isViewer, // viewer以外は削除可能（サーバー側でリレーションチェック）
    canManage: isManagerOrAdmin, // admin/managerのみ管理操作可能

    // メッセージ取得
    getDisabledMessage: (action: 'edit' | 'delete' | 'manage'): string | undefined => {
      if (action === 'edit' && isViewer) {
        return '閲覧権限のため、この操作はできません';
      }
      if (action === 'delete' && isViewer) {
        return '閲覧権限のため、この操作はできません';
      }
      if (action === 'manage' && !isManagerOrAdmin) {
        return '管理者またはマネージャー権限が必要です';
      }
      return undefined;
    },
  };
}
